import axiosInstance from "services/AxiosInstance";

export const accountDetails = async (id: string) => {
  const response = await axiosInstance.get(`/accounts/${id}`);
  return response.data;
};
